import { defineStore, storeToRefs } from "pinia";
import api from "@/services/api";
import { useAuthStore } from '@/stores';

export const useMaintenanceStore = defineStore("maintenance", {
  state: () => ({
    error: "" as any,
  }),
  actions: {
    async resetAllCaches() {
      const authStore = useAuthStore();

      const { isAuthenticated } = storeToRefs(authStore);

      if (!isAuthenticated.value) return;

      await api
        .post("v1.0/maintenance/.reset-all-caches")
        .catch((error) => (this.error = error));
    },
    async signalStaticContentChanged() {
      const authStore = useAuthStore();

      const { isAuthenticated } = storeToRefs(authStore);

      if (!isAuthenticated.value) return;

      await api
        .post("v1.0/signals/scc")
        .catch((error) => (this.error = error));
    },
    async signalMasterdataChanged(tenantId: number | null = null) {
      const authStore = useAuthStore();

      const { isAuthenticated } = storeToRefs(authStore);

      if (!isAuthenticated.value) return;

      let url = `v1.0/signals/mdc`;
      if (tenantId !== null) {
        url += `?tenantId=${tenantId}`;
      }
      await api
        .post(url)
        .catch((error) => (this.error = error));
    },
    async forceAutoOrder() {
      const authStore = useAuthStore();

      const { isAuthenticated } = storeToRefs(authStore);

      if (!isAuthenticated.value) return;

      await api
        .post("v1.0/maintenance/.force-auto-order")
        .catch((error) => (this.error = error));
    }
  },
});
